import $ from "jquery";

$( () => {
    const carousels = document.querySelectorAll('.carousel');
    carousels.forEach(function (element) {
        const carousel = element.querySelector('.carousel-wrapper');
        const cells = carousel.querySelectorAll('.carousel-card');
        let cellCount; // cellCount set from cells-range input value
        let cellWidth;
        let cellHeight;
        let selectedIndex = 0;
        let isHorizontal = true;
        let rotateFn = isHorizontal ? 'rotateY' : 'rotateX';
        let radius, theta;

        function rotateCarousel() {
            const angle = theta * selectedIndex * -1;
            const cleanAngle = theta * (selectedIndex % cellCount) * -1;
            carousel.style.transform = 'translateZ(' + -radius + 'px) ' +
                rotateFn + '(' + angle + 'deg)';
            for (let i=0; i < cells.length; i++ ) {
                const cellAngle = Math.abs(theta * i + cleanAngle);
                const cell = cells[i];
                let opacity = ((Math.abs(cellAngle - 180) / 180) * (1 - 0.2) + 0.2);
                if (opacity > 1) {
                    opacity = 1 - opacity % 1;
                }
                cell.style.opacity = opacity + '';
                if (opacity === 1) {
                    cell.classList.add('carousel-card--active');
                } else {
                    cell.classList.remove('carousel-card--active');
                }
            }
        }

        const prevButton = document.querySelector('.carousel-button-prev');
        prevButton.addEventListener( 'click', prev);

        const nextButton = document.querySelector('.carousel-button-next');
        nextButton.addEventListener( 'click', next);

        cells.forEach((cell, newIndex) => {
            cell.addEventListener('click', () => {
                let cleanSelectedIndex = selectedIndex % cellCount;
                if (cleanSelectedIndex < 0) {
                    cleanSelectedIndex = cellCount + cleanSelectedIndex;
                }
                if ((cleanSelectedIndex > newIndex && newIndex !== 0)
                    || (cleanSelectedIndex === 0 && newIndex === cellCount - 1)
                    || (cleanSelectedIndex === 1 && newIndex === 0)
                ) {
                    prev();
                } else if (cleanSelectedIndex !== newIndex) {
                    next();
                }
            });
        });

        function prev() {
            selectedIndex--;
            rotateCarousel();
        }

        function next() {
            selectedIndex++;
            rotateCarousel();
        }

        function changeCarousel() {
            cellWidth = carousel.offsetWidth;
            cellHeight = carousel.offsetHeight;
            cellCount = cells.length;
            theta = 360 / cellCount;
            const cellSize = isHorizontal ? cellWidth : cellHeight;
            radius = Math.round( ( cellSize / 2) / Math.tan( Math.PI / cellCount ) );
            for (let i=0; i < cells.length; i++ ) {
                const cellAngle = theta * i;
                const cell = cells[i];
                cell.style.transform = rotateFn + '(' + cellAngle + 'deg) translateZ(' + radius + 'px)';
            }
            //carousel.style.setProperty('--calculated-width', (carousel.parentElement.offsetWidth / Math.PI) + 'px');
            rotateCarousel();
        }

        function onOrientationChange() {
            isHorizontal = window.matchMedia("(orientation: landscape)").matches;
            rotateFn = isHorizontal ? 'rotateY' : 'rotateX';
            changeCarousel();
        }

        window.addEventListener('resize', function() {
            requestAnimationFrame(onOrientationChange);
        });

        // set initial
        onOrientationChange();
    });

});